import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form } from "react-bootstrap";
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_URL } from '../../../api/api';

const API_CATEGORY = `${API_URL}/product-categories`;

const ManageCategoryLayer = () => {
    const [categories, setCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({ name: '', status: 'active' }); // Added status here
    const [editId, setEditId] = useState(null);
    const token = localStorage.getItem('token');
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    // Fetch all product categories
    const fetchCategories = () => {
        axios.get(API_CATEGORY)
            .then(res => setCategories(res.data))
            .catch(err => console.error('Error fetching categories:', err));
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Open modal for Add or Edit
    const handleShowModal = (category = null) => {
        if (category) {
            setEditId(category.id);
            setForm({ name: category.name, status: category.status || 'active' }); // Populate status
        } else {
            setEditId(null);
            setForm({ name: '', status: 'active' }); // Reset form with default status
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditId(null);
        setForm({ name: '', status: 'active' });
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.name.trim()) {
            Swal.fire("Validation Error", "Category name is required", "error");
            return;
        }

        if (!form.status) {
            Swal.fire("Validation Error", "Status is required", "error");
            return;
        }

        try {
            if (editId) {
                await axios.put(`${API_CATEGORY}/${editId}`, form);
                Swal.fire("Updated", "Category updated successfully", "success");
            } else {
                await axios.post(API_CATEGORY, form);
                Swal.fire("Added", "Category added successfully", "success");
            }

            handleCloseModal();
            fetchCategories();
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Operation failed", "error");
        }
    };

    // Delete category
    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This will delete the category.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!"
        });

        if (confirm.isConfirmed) {
            try {
                await axios.delete(`${API_CATEGORY}/${id}`);
                Swal.fire("Deleted!", "Category has been deleted.", "success");
                fetchCategories();
            } catch (err) {
                console.error(err);
                Swal.fire("Error", "Delete failed", "error");
            }
        }
    };

    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="card-title mb-0">Manage Product Categories</h6>
                        <Button variant="primary" size="sm" onClick={() => handleShowModal()}>
                            <i className="ri-add-line" /> Add Category
                        </Button>
                    </div>
                    <div className="card-body">
                        <Table bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Category Name</th>
                                    <th>Status</th>
                                    <th style={{ width: "150px" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories.length > 0 ? (
                                    categories.map((cat, index) => (
                                        <tr key={cat.id}>
                                            <td>{index + 1}</td>
                                            <td>{cat.name}</td>
                                            <td>{cat.status}</td>
                                            <td>
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => handleShowModal(cat)}
                                                >
                                                    Edit
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(cat.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No categories found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {/* Modal for Add/Edit */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <h6>{editId ? 'Edit' : 'Add'} Product Category</h6>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Category Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder="Enter category name"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={form.status}
                                onChange={handleChange}
                                required
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Form.Select>
                        </Form.Group>
                        <div className="text-end">
                            <Button variant="secondary" onClick={handleCloseModal} className="me-2">
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit">
                                {editId ? 'Update' : 'Add'}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ManageCategoryLayer;
